import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Withdrawal } from "./withdrawal.component";
import { Grid } from "@mui/material";

export function WithdrawalModal({ ibInfo, txMethod }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Grid container sx={{ padding: "15px", color: "#fff !important;" }} gap={1}>
      {txMethod.isDateAllowed ? (
        <Button
          variant="contained"
          sx={{
            height: "50px",
            borderRadius: "10px",
            color: "white !important",
            fontWeight: "700",
            fontSize: "16px",
            "&:hover": {
              color: "white !important",
            },
          }}
          onClick={handleOpen}
        >
          Solicitar retiro
        </Button>
      ) : (
        <Typography
          color={"white"}
          sx={{
            color: "#fff",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontWeight: "700",
            fontSize: "15px",
          }}
        >
          {txMethod.configuration?.allowedDaysMsg}
        </Typography>
      )}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            height: 420,
            bgcolor: "#011a3d",
            borderRadius: 6,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            variant="h4"
            color={"white"}
            sx={{
              color: "#FFFFFF",
              textAlign: "center",
              whiteSpace: "nowrap",
              fontWeight: "700",
            }}
          >
            Retiros
          </Typography>
          <Box sx={{ padding: "20px", height: "100%" }}>
            <Withdrawal ibInfo={ibInfo} handleClose={handleClose} txMethod={txMethod} />
          </Box>
        </Box>
      </Modal>
    </Grid>
  );
}
